import { calculateDifferencesNight } from "@website/accommodation-ui/helpers";
import { MaterialIcon, MaterialNameType } from "@website/icons/material";
import { InfoChips } from "@website/ui/info-chips";
import { numberConvert } from "@website/utils/number-convert";
import { FiltersSchemaType } from "@website/widget/filter";
import uniqueId from "lodash-es/uniqueId";
import { ResponseFilterType } from "./types";
interface Properties {
  stDate: string;
  rtDate: string;
  roomCount: number;
  availableFilters: ResponseFilterType;
}
const transportTypes = {
  flight: "پرواز",
  train: "قطار"
};
export function useSolutionsFilters({
  stDate,
  rtDate,
  roomCount,
  availableFilters
}: Properties) {
  const priceFilter = availableFilters.find(index => index.name === "price");
  const starsFilter = availableFilters.find(index => index.name === "stars");
  const facilitiesFilter = availableFilters.find(index => index.name === "facilities");
  const ratingsFilter = availableFilters.find(index => index.name === "ratings");
  const transportTypesFilter = availableFilters.find(index => index.name === "transportTypes");
  const ratesInfoChips = {
    "4.5": {
      text: "عالی",
      color: "success"
    },
    "4": {
      text: "خیلی خوب",
      color: "success"
    },
    "3.5": {
      text: "خوب",
      color: "default"
    }
  };
  const filtersSchema: FiltersSchemaType = {
    hotel_name: {
      type: "input",
      title: "جستجو بر اساس نام هتل"
    },
    ...(transportTypesFilter && "transportTypes" in transportTypesFilter ? {
      transport_types: {
        title: "نحوه حمل و نقل",
        type: "checkbox",
        options: [...transportTypesFilter.transportTypes].map(t => ({
          label: transportTypes[t.toLowerCase()],
          name: t
        })).filter(t => Boolean(t.label))
      }
    } : {}),
    ...(priceFilter && "min" in priceFilter ? {
      price_range: {
        title: "قیمت",
        description: `مجموع قیمت برای ${numberConvert(roomCount, {
          locale: "fa"
        })} اتاق ${numberConvert(calculateDifferencesNight(stDate, rtDate), {
          locale: "fa"
        })} شب`,
        type: "range",
        min_key: "price_from",
        max_key: "price_to",
        step: 1,
        min: Math.floor(priceFilter.min / 10),
        max: Math.floor(priceFilter.max / 10)
      }
    } : {}),
    ...(starsFilter && "stars" in starsFilter && starsFilter.stars.length > 0 ? {
      stars: {
        type: "checkbox",
        title: "ستاره هتل",
        options: [...starsFilter.stars].sort((a, b) => b - a).map(star => ({
          name: `${star}`,
          label: star ? `${numberConvert(star, {
            locale: "fa"
          })} ستاره` : "اقامتگاه‌های بدون ستاره",
          icon: Boolean(star) && <div className="flex">
                    {Array.from({
              length: star
            }, () => <MaterialIcon className="text-on-surface-high-emphasis text-xs" key={uniqueId()} name="star" />)}
                  </div>
        }))
      }
    } : {}),
    ...(ratingsFilter && "ratings" in ratingsFilter && ratingsFilter.ratings.length > 1 ? {
      rate: {
        type: "radio",
        title: "امتیاز کاربران",
        defaultValue: "all",
        items: [{
          value: "all",
          label: "همه"
        }, ...ratingsFilter.ratings.sort((a, b) => b - a).map(rate => ({
          value: rate === 0 ? "new" : String(rate),
          icon: ratesInfoChips[String(rate)] && <InfoChips StartIcon={<MaterialIcon className="text-body-2" name="stars" />} color={ratesInfoChips[String(rate)]?.color || ""} size="medium" text={ratesInfoChips[String(rate)]?.text || ""} variant="round-accent" />,
          label: rate === 0 ? "اقامتگاه‌های بدون امتیاز" : `${numberConvert(rate, {
            locale: "fa"
          })}+ امتیاز`
        }))]
      }
    } : {}),
    ...(facilitiesFilter && "facilities" in facilitiesFilter && facilitiesFilter.facilities.length > 0 ? {
      facilities: {
        type: "checkbox",
        title: "امکانات هتل",
        collapsible: facilitiesFilter.facilities.length > 5,
        options: [...facilitiesFilter.facilities].sort((a, b) => b.id - a.id).map(({
          icon,
          title,
          id
        }) => ({
          name: `${id}`,
          label: title,
          icon: <MaterialIcon className="text-on-surface-medium-emphasis text-headline-5" name={icon === "what.ico" ? "check_box" : icon as MaterialNameType} variant="outlined" />
        }))
      }
    } : {})
  };
  return {
    filtersSchema
  };
}